import React, { useEffect, useState } from 'react';
import { Formik, Field, Form, ErrorMessage} from 'formik';
import * as Yup from 'yup';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

const ChangiForm = () => {
    const [isLandsideStaff, setIsLandsideStaff] = useState(false);
    const [isAircrew, setIsAircrew] = useState(true);
    const [isAPH, setIsAPH] = useState(false);
    const [submissionStatus, setSubmissionStatus] = useState(null);
    const [submissionStatus_ap, setSubmissionStatus_ap] = useState(null);
    const [responseMessage, setResponseMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [uid, setUid] = useState('');
    const [givenName, setGivenName] = useState('');
    const [familyName, setFamilyName] = useState('');
    const [welcome_email, setWelcomeEmail] = useState('');
    const [isLogin, setIsLogin] = useState(false);
    const [message, setMessage] = useState('');
    const [consent, setConsent] = useState(false);

    const apiKey = "4_-_Y0F5r8UxkaBeDMEmK3wg";
    const clientId = "DYSUAibcpXDcqPQmjFnjb-sq";
    const redirectUrl = "https://dev-crsp.changiairport.com/";
    const tokenUrl = "https://1xqckvj3if.execute-api.ap-southeast-1.amazonaws.com/dev/token";

    useEffect(() => {

        setIsLoading(true);

        if (getCookie('uid')=='' || getCookie('uid')==null){
            console.log('uid not found in cookie');
            // Get the current URL's query string
            const queryString = window.location.search;

            // Use URLSearchParams to parse the query string
            const urlParams = new URLSearchParams(queryString);

            // Check if a specific parameter exists
            if (urlParams.has('code')) {
                // Get the value of the parameter
                const code = urlParams.get('code');
                console.log('Value of code:', code);
                token(code);
                //setIsLoading(false);
            } else {
                console.log('code not found in URL');
                //setIsLoading(false);
            }
        }
        else{

            console.log('uid found in cookie ' + getCookie('uid'));
            setIsLogin(true);
            setUid(getCookie('uid'));
            setWelcomeEmail(getCookie('email'));
            setGivenName(getCookie('given_name'));
            setFamilyName(getCookie('family_name'));  
            //setIsLoading(false);
        }

        setIsLoading(false);
        
    }, []); 

    useEffect(() => {
        if (uid && welcome_email && givenName && familyName) {
            const newMessage = (
                <>
                    Hello, <b>{givenName} {familyName}</b>!<br /><br />
                    We will be using <b>{welcome_email}</b><br />
                    to activate your Changi Rewards Staff Programme.<br />
                </>
            );
            //const newMessage = `Hello, ${givenName} ${familyName}! We will be using ${welcome_email} to activate your Changi Rewards Staff Programme.`;
            setMessage(newMessage);
            console.log('message updated:', newMessage);
        }
    }, [uid, welcome_email, givenName, familyName]);

    const setCookie = (name, value, days) => {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    };
    
    const handleLoginSuccess = (userData) => {
        // Assuming userData is an object with uid, given_name, family_name, and email
        setCookie('uid', userData.uid, 1); // Set cookie for 7 days
        setCookie('given_name', userData.given_name, 1);
        setCookie('family_name', userData.family_name, 1);
        setCookie('email', userData.email, 1);
        console.log('isLogin: '+ isLogin);
    };

    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
    };

    const deleteCookie = (name) => {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
        return null;
    };

    const handleLogOut =(event) =>{
        event.preventDefault();
        deleteCookie('uid');
        deleteCookie('given_name');
        deleteCookie('family_name');
        deleteCookie('email');
        setIsLogin(false);
        window.location.href=logoutUrl;
        return null;
    }

    const token = (code) =>{
        const tokenPayload = {
            code: code,
            token_path: 'galaxy',
        }
        fetch(tokenUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key':process.env.REACT_APP_TOKEN_API_KEY
            },
            body: JSON.stringify(tokenPayload)
        })
        .then(response => response.json())
        .then(data => {
            console.log('Success:', data);
            setUid(data.uid);
            setGivenName(data.given_name);
            setFamilyName(data.family_name);
            setWelcomeEmail(data.email);
            setMessage(`Hello, ${givenName} ${familyName}! We will be using ${welcome_email} to activate your Changi Rewards Staff Programme.`)
            console.log('message in token: '+ message);
            console.log('givenName in token: '+ givenName);
            console.log('familyName in token: '+ familyName);
            console.log('welcome_email in token: '+ welcome_email);
            setIsLogin(true);

            const loginResponseData = {
                uid: data.uid,
                given_name: data.given_name,
                family_name: data.family_name,
                email: data.email
            }
            handleLoginSuccess(loginResponseData);

        })
        .catch((error) => {
            console.error('Error:', error);
        });
    
    }
    // Validation Schema
    let validationSchema;

    if (isLogin){
        validationSchema = Yup.object().shape({
            isAPH: Yup.string(),
            isAPH1: Yup.string(),
            isAircrew: Yup.string(),
            cr_email: Yup.string().email('Invalid email'),
            cr_card_number: Yup.string().matches(/^\d{19}$/, 'Must be a 19 digit number'),
            aph: Yup.string().required('Selecting Yes or No is required'),

            pass_number: Yup.string().matches(/^(?:[Ss]\d{7}|CA\d{7}|A\d{7})$/, 'Invalid Pass Number').nullable(),
            pass_expiry: Yup.date().nullable().min(new Date(), 'Date cannot be in the past'),

            zones: Yup.array()
                .of(Yup.string())
                .when('isAPH', {
                    is: 'true',
                    then: () => Yup.array().min(1, 'At least one selection is required'),
                    otherwise: () => Yup.array().nullable(),
                }),
            //gender: Yup.string().required('Required'),
            company_name: Yup.string().required('Company Name is required'),
            corporate_email: Yup.string().email('Invalid email'),
            aircrew: Yup.string().required('Selecting Yes or No is required'),
            //landside: Yup.string().required('Selecting Yes or No is required'),
            landside: Yup.string().when('aircrew', {
                is: 'false', 
                then: () => Yup.string().required('Selecting Yes or No is required for landside'),
                otherwise: () => Yup.string(), // not required when aircrew is not "No"
            }),
            signup_source: Yup.string(),
            completed_training: Yup.string().when('landside', {
                is: 'true', 
                then: () => Yup.string().required('Selecting training completion is required for landside'),
                otherwise: () => Yup.string(), // not required when aircrew is not "No"
            }),
            consent_granted: Yup.boolean().oneOf([true],'Consent is required to proceed'),
            // primary_area: Yup.string().when('landside', {
            //     is: 'true', 
            //     then: () => Yup.string().required('Selecting primary area is required for landside'),
            //     otherwise: () => Yup.string(), // not required when aircrew is not "No"
            //}),
            primary_area:Yup.string().nullable(),

        });
    }
    else{
        validationSchema = Yup.object().shape({
            isAPH: Yup.string(),
            isAPH1: Yup.string(),
            isAircrew: Yup.string(),
            //cr_email: Yup.string().email('Invalid email').required('Required'),
            cr_email: Yup.string().email('Invalid email').nullable(),
            cr_card_number: Yup.string().matches(/^\d{19}$/, 'Must be a 19 digit number').required('Required'),
            aph: Yup.string().required('Selecting Yes or No is required'),

            pass_number: Yup.string().matches(/^([Ss]\d{7}|CA\d{7}|A\d{7})$/, 'Invalid Pass Number').nullable(),
            pass_expiry: Yup.date().nullable().min(new Date(), 'Date cannot be in the past'),

            zones: Yup.array()
                .of(Yup.string())
                .when('isAPH', {
                    is: 'true',
                    then: () => Yup.array().min(1, 'At least one selection is required'),
                    otherwise: () => Yup.array().nullable(),
                }),
            //gender: Yup.string().required('Required'),
            company_name: Yup.string().required('Company Name is required'),
            corporate_email: Yup.string().email('Invalid email'),
            aircrew: Yup.string().required('Selecting Yes or No is required'),
            //landside: Yup.string().required('Selecting Yes or No is required'),
            landside: Yup.string().when('aircrew', {
                is: 'false', 
                then: () => Yup.string().required('Selecting Yes or No is required for landside'),
                otherwise: () => Yup.string(), // not required when aircrew is not "No"
            }),
            signup_source: Yup.string(),
            completed_training: Yup.string().when('landside', {
                is: 'true', 
                then: () => Yup.string().required('Selecting training completion is required for landside'),
                otherwise: () => Yup.string(), // not required when aircrew is not "No"
            }),
            consent_granted: Yup.boolean().oneOf([true],'Consent is required to proceed'),
            // primary_area: Yup.string().when('landside', {
            //     is: 'true', 
            //     then: () => Yup.string().required('Selecting primary area is required for landside'),
            //     otherwise: () => Yup.string(), // not required when aircrew is not "No"
            // }),
            primary_area:Yup.string().nullable(),

        });        
    }

    // Handle form submission
    const handleSubmit = (values, {resetForm}) => {
        
        console.log('in handleSubmit');
        setIsLoading(true);
        console.log('isLoading: %s', isLoading);

        // dont want to include isAPH
        let { isAPH, aph, cr_email, isAircrew, landside, aircrew, pass_expiry, consent_granted, ...otherValues } = values;
        let formattedPassExpiry;
        let checkboxString;

        if (aph !== 'false'){
        //let formattedPassExpiry = pass_expiry ? new Date(pass_expiry).toISOString().split('T')[0] : null;
        formattedPassExpiry = pass_expiry ? new Date(new Date(pass_expiry).getTime() + 8 * 60 * 60 * 1000).toISOString().split('T')[0] : null;
        checkboxString = values.zones.map(item => item.toUpperCase()).join(',');
        }
        else{
            formattedPassExpiry = null;
            checkboxString = '';
        }
        
        console.log(checkboxString);

        if (aircrew === 'true'){
            landside = 'false';
            console.log(values.landside)
        }

        if(landside === 'true'){
            aircrew = 'false';
        }

        if (isLogin){
            cr_email = welcome_email;

        }

        const payload = {
            ...otherValues,
            pass_expiry: formattedPassExpiry,
            zones: checkboxString,
            landside: landside,
            aircrew: aircrew,
            cr_email: cr_email,
            uid: uid,
            aph:aph
        };

        console.log(payload);

        const apiUrl = 'https://1xqckvj3if.execute-api.ap-southeast-1.amazonaws.com/dev/submitform';

        if (values.aph == 'true' && (values.pass_number == '' || values.pass_expiry == null || values.zones == '')){
            setSubmissionStatus_ap('error');
            setResponseMessage('Airport Pass Number, Airport Pass Expiry Date and Zones are required');
            setIsLoading(false);
        }
        else{
            fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': process.env.REACT_APP_FORM_API_KEY
                },
                body: JSON.stringify(payload)
            })
            .then(response => response.json())
            .then(data => {
                console.log('Success:', data);
                setSubmissionStatus('success');
                setResponseMessage(data.message || 'Changi Rewards Staff successfully registered');
                setIsLoading(false);
                console.log('isLoading: %s', isLoading);
            })
            .catch((error) => {
                console.error('Error:', error);
                setSubmissionStatus('error');
                setResponseMessage('Changi Rewards Staff registration failed');
                setIsLoading(false);
                console.log('isLoading: %s', isLoading);
            });
        }

        
   
    };

    const closeModal = (resetForm) => {
        setSubmissionStatus(null);
        setResponseMessage('');
        resetForm();
    };

    const closeModal_ap = (resetForm) => {
        setSubmissionStatus(null);
        setResponseMessage('');
        setSubmissionStatus_ap(false);
    };

    let loginUrl = `https://uat-auth1.changiairport.com/oidc/op/v1.0/${apiKey}/authorize?client_id=${clientId}&redirect_uri=${redirectUrl}&scope=openid+profile+email+phone+UID&response_type=code`;
    let logoutUrl = `https://uat-auth.changiairport.com/logout?callback=${redirectUrl}`;
    
    return (
        <Formik
            initialValues={{
                cr_email: '',
                cr_card_number: '',
                aph: '',
                pass_number: '',
                pass_expiry: null,
                landside: '',
                zones: [],
                //gender:'',
                company_name: '',
                corporate_email: '',
                aircrew: '',
                signup_source: 'form',
                completed_training: 'Not Required',
                consent_granted: false,
                isAPH: isAPH ? 'true' : 'false',
                isAircrew: isAircrew ? 'true' : 'false',
                primary_area: ''


            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            {({ setFieldValue, values, resetForm }) => (
                
                
                <div className="flex-container">

                <div className="instructions-container">

                    <div className="instructions-text-container"></div>
                    
                    <div className="instructions-text-container">
                        <div className="image-container-cr"></div>
                    </div>
                   
                    <h1>Changi Rewards Staff Programme (CRSP)</h1>

                    <div className="instructions-text-container">
                            [DEV] Hi there!
                        </div>
                        <div className="instructions-text-container">
                            Welcome to the Changi Rewards Staff Programme!
                        </div>
                        <div className="instructions-text-container">
                            CRSP is a new initiative by Changi Airport Group that aims to unite the entire airport community, ensuring that every airport staff (airport pass holders and non-airport pass holders) can enjoy expanded perks, exclusive deals and special programmes across retail stores, dining outlets, and staff canteens.
                        </div>
                        <div className="instructions-text-container">
                            Membership in CRSP is free for all employees working at Changi Terminals, Changi Airfreight Centre, and Jewel Changi Airport.
                        </div>
                        <div className="instructions-text-container">
                            To sign up:
                            <ol>
                                <li>Download the Changi App on the <a href='https://changi.me/3tlWPKN' target='_blank' rel='noreferrer'>Apple App store or the Google Play store</a></li>
                                <li><a href='https://rewards.changiairport.com/en/signup.html' target='_blank' rel='noreferrer'>Register</a> for a Changi Rewards account</li>
                                <li>Fill out the form on this page by logging in to your Changi Rewards account and submitting the information required</li>
                            </ol>
                        </div>
                        <div className="instructions-text-container">
                            Your Changi Rewards account will be converted to a staff account within 2 days after submission of the required information.
                        </div>
                        <div className="instructions-text-container">
                            <div className="instructions-image-container">
                                <img src='https://dev-crsp.changiairport.com/rewards_card_image.png' alt='rewards card' />
                            </div>
                        </div>
                        <div className="instructions-text-container">
                            Show your Changi Airport Staff Rewards e-Card when shopping and dining around the airport to enjoy discounts at participating outlets.
                        </div>
                        <div className="instructions-text-container">
                            Please note that all frontliner staff would need to complete their Changi Orientation Programme (COP) or Jewel Orientation Programme (JOP) before signing up.
                        </div>
                        <div className="instructions-text-container">
                        To learn more about the benefits of CRSP, please click <a href='https://changi.me/crsp' target='_blank' rel='noreferrer'>here</a>
                        </div>
                        <div className="instructions-text-container">
                            For any enquiries or assistance, please reach out to us at <a href='mailto:crsp.enquiry@changiairport.com' target='_blank' rel='noreferrer'>crsp.enquiry@changiairport.com</a>. 
                        </div>
                        <div className="instructions-text-container">
                            We look forward to welcoming you to the CRSP community and providing you with a rewarding experience!
                        </div>

                        <div className="instructions-text-container">
                            <div className="image-container-cag"></div>
                        </div>
                        <div className="instructions-text-container">
                        
                        </div>
                </div> 

                <Form className="form-container">

                    {submissionStatus && (
                        <div className="overlay">
                            <div className="modal">
                                {responseMessage}<br />
                                <button type="button" onClick={() => closeModal(resetForm)}>OK</button>
                            </div>
                        </div>
                    )}

                    {submissionStatus_ap && (
                        <div className="overlay">
                            <div className="modal">
                                {responseMessage}<br />
                                <button type="button" onClick={() => closeModal_ap()}>OK</button>
                            </div>
                        </div>
                    )}  

                    <div className="title-container">
                        <div className="title-text">Sign Up</div>

                    </div>

                    {!isLogin && (
                            <a href={loginUrl} className="login-button-style">Login to Changi Account and Retrieve Your Profile</a>
                        )}

                        {isLogin && (
                            <a href={logoutUrl} onClick={handleLogOut} className="login-button-style">Logout</a>
                        )}     

                    <div className="login-details-container">


                  
                        {message}
                       
                        
                        {!isLogin && (

                            <Field type="hidden" name="cr_email" value="" />
                        )}

                        {isLogin && (
                             <Field type="hidden" name="cr_email" value={welcome_email} />
                        )}

                        {!isLogin && (
                            <div className="sub-question-container">
                                <label>Changi Rewards Card Number</label>
                                <div>
                                    <Field name="cr_card_number" type="text" maxLength={19}/>
                                    <ErrorMessage name="cr_card_number" component="div" className="error-message"/>
                                </div>
                            </div>
                           )}
                    </div>
                    
                    <Field type="hidden" name="isAPH" value={isAPH ? 'true' : 'false'} />

                    <div className="question-container">
                        
                        <div className="sub-question-container">
                            <label>Do you have an Airport Pass?</label>
                            <div className="checkbox-container">
                                <div className="radio-option">
                                    <Field type="radio" className="large-radio" name="aph" value="true" onChange={() => {setIsAPH(true); setFieldValue('aph','true')}} /> Yes
                                </div>
                                <div className="radio-option">
                                    <Field type="radio" className="large-radio" name="aph" value="false" onChange={() => {setIsAPH(false); setFieldValue('aph','false'); setFieldValue('pass_number',''); setFieldValue('pass_expiry',''); setFieldValue('zones','')}} /> No
                                </div>
                               
                            </div>
                            <ErrorMessage name="aph" component="div" className="error-message"/>
                        </div>                                


                        {isAPH && (
                            <div>
                                    <div className="sub-question-container">
                                    <label>Airport Pass Number (APH Number)</label>
                                    <div>
                                        <Field name="pass_number" type="text" maxLength={9} />
                                        <ErrorMessage name="pass_number" component="div" className="error-message"/>
                                    </div>
                                </div>

                                <div className="sub-question-container">
                                    <label>Airport Pass Expiry Date</label>
                                    <div>
                                        <DatePicker 
                                            selected={values.pass_expiry}
                                            onChange={date => setFieldValue('pass_expiry', date)}
                                            dateFormat="yyyy-MM-dd"
                                        />
                                        <ErrorMessage name="pass_expiry" component="div" className="error-message"/>
                                    </div>
                                </div>

                                <div className="sub-question-container">
                                    <label>What access does your Airport Pass have?</label>
                                    <div className="checkbox-container-1">
                                        {["Half-A", "A", "B", "C", "D", "T", "V"].map(option => (
        
                                                <div key={option} className="checkbox-option">
                                                        <Field 
                                                        className="large-checkbox"
                                                        type="checkbox" 
                                                        name="zones" 
                                                        value={option} 
                                                    />
                                                    
                                                    {option}
                                                </div>
                                  
                                        ))}
                                        <ErrorMessage name="zones" component="div" className="error-message"/>
                                    </div>
                                </div>

                            </div>
                        )}
                        
                    </div>
{/*}
                    <div className="question-container">
                        <div className="sub-question-container">
                            <label>Gender</label>
                            <div className="checkbox-container">
                                <div className="radio-option">
                                    <Field type="radio" name="gender" value="Male" className="large-radio" /> Male
                                </div>
                                <div className="radio-option">
                                    <Field type="radio" name="gender" value="Female" className="large-radio" /> Female
                                </div>
                            </div>
                            <ErrorMessage name="gender" component="div" className="error-message"/>
                        </div>
                    </div>
*/}

                    <div className="question-container">
                        <div className="sub-question-container">
                            <label>Company Name</label>
                            <div>
                                <Field name="company_name" type="text" />
                                <ErrorMessage name="company_name" component="div" className="error-message"/>
                            </div>
                        </div>


                        <div className="sub-question-container">
                            <label>Corporate Email</label>
                            <div>
                                <Field name="corporate_email" type="text" />
                                <ErrorMessage name="corporate_email" component="div" className="error-message"/>
                            </div>
                        </div>
                    </div>                                                                

                    <div>
                        {isLoading && (
                            <div className="loading-overlay">
                                <div className="spinner">
                                    <div className="dot"></div>
                                    <div className="dot"></div>
                                    <div className="dot"></div>
                                </div>
                            </div>
                        )}
                    </div>


                    <div className="question-container">    
                        
                        <Field type="hidden" name="isAircrew" value={isAircrew ? 'true' : 'false'} />
                        <Field type="hidden" name="signup_source" value="form" />
     
                        <div className="sub-question-container">
                            <label>Are you an Air Crew?</label>
                            <div className="checkbox-container">
                                <div className="radio-option">
                                    <Field type="radio" name="aircrew" value="true" className="large-radio" onChange={() => {setIsAircrew(true); setIsLandsideStaff(false);setFieldValue('primary_area','');setFieldValue('landside','');setFieldValue('completed_training','Not Required');setFieldValue('aircrew','true')}}/> Yes
                                </div>
                                <div className="radio-option">
                                    <Field type="radio" name="aircrew" value="false" className="large-radio" onChange={() => {setIsAircrew(false); setFieldValue('completed_training','');setFieldValue('aircrew','false')}}/> No
                                </div>
                            </div>
                            <ErrorMessage name="aircrew" component="div" className="error-message"/>
                        </div>

                        {isAircrew === false && (
                            <div className="sub-question-container">
                                <label>Are you a frontline staff (i.e. non-office staff e.g. F&B, retail front-of-house / back-of-house, ground staff etc)?</label>
                                <div className="checkbox-container">
                                    <div className="radio-option">
                                        <Field className="large-radio" type="radio" name="landside" value="true" onChange={() => {setIsLandsideStaff(true);setFieldValue('primary_area','');setFieldValue('landside','true')}} /> Yes
                                    </div>
                                    <div className="radio-option">
                                        <Field className="large-radio" type="radio" name="landside" value="false" onChange={() => {setIsLandsideStaff(false); setFieldValue('completed_training','Not Required');setFieldValue('landside','false')}} /> No
                                    </div>
                                </div>
                                <ErrorMessage name="landside" component="div" className="error-message"/>
                            </div>   
                        )} 
                        
                        {isLandsideStaff && (

                            
                            <div>
                                {/*
                                <div className="sub-question-container">
                                    <label>Where is your primary area of frontline work?</label>
                                    <div className="checkbox-container-1">
                                        <div className="radio-option-1">
                                            <Field type="radio" className="large-radio" name="primary_area" value="Changi Airport Terminals (Retail/F&B e.g. Shilla or Ya Kun)" />Changi Airport Terminals (Retail/F&B e.g. Shilla, Ya Kun)   
                                        </div>
                                        <div className="radio-option-1">
                                            <Field type="radio" className="large-radio" name="primary_area" value="Changi Airport Terminals (Services e.g. KinderPLAY or Smarte Carte)" />Changi Airport Terminals (Services e.g. KinderPLAY, Smarte Carte)
                                        </div>
                                        <div className="radio-option-1">
                                            <Field type="radio" className="large-radio" name="primary_area" value="Jewel Changi Airport (Retail/F&B, e.g. Apple or Birds of Paradise)" />Jewel Changi Airport (Retail/F&B, e.g. Apple, Birds of Paradise)
                                        </div>
                                        <div className="radio-option-1">
                                            <Field type="radio" className="large-radio" name="primary_area" value="Jewel Changi Airport (Services e.g. FXChange)" />Jewel Changi Airport (Services e.g. FXChange)
                                        </div>
                                    </div>
                                    <ErrorMessage name="primary_area" component="div" className="error-message"/>
                                </div>
                                */}

                                <div className="sub-question-container">
                                    <label>Have you completed your Changi Orientation Programme / Jewel Orientation Programme (JOP) training?</label>
                                    <div className="checkbox-container">
                                        <div className="radio-option">
                                            <Field type="radio" className="large-radio" name="completed_training" value="Yes" /> Yes
                                        </div>
                                        <div className="radio-option">
                                            <Field type="radio" className="large-radio" name="completed_training" value="No" /> No
                                        </div>
                                        {/*}
                                        <div className="radio-option">
                                            <Field type="radio" className="large-radio" name="completed_training" value="Not Required" /> Not Required
                                        </div>
                                        */}
                                    </div>
                                    <ErrorMessage name="completed_training" component="div" className="error-message"/>
                                </div>
                            </div>
                        )}
                        
                    </div>
                    <div className="question-container">
                        <div className="sub-question-container">
                            <label className="privacy-policy-label">CAG Privacy Policy</label>
                            <label className="checkbox-container-2">
                                <Field className="large-checkbox-1" type="checkbox" name="consent_granted" 
                                    onChange = {event => {
                                        const checked_consent = event.target.checked;
                                        setConsent(checked_consent);
                                        setFieldValue('consent_granted', checked_consent);
                                        }
                                    }
                                />
                                I declare that all the information I provided is correct, accurate and true.
                                I consent for my personal data to be collected, used and/or disclosed by members of the CAG Group for the administration of my Changi Account and for the purposes set out in Changi Airport Group (Singapore) Pte. Ltd.’s Privacy Policy (<a href="https://www.changiairport.com/en/privacy-policy.html" rel="noreferrer" target="_blank"className="privacy-link">https://www.changiairport.com/en/privacy-policy.html</a>).
                            </label>    
                                 
                            <ErrorMessage name="consent_granted" component="div" className="error-message"/>
                        </div>    
                    </div>

                    <button className="submit-button" type="submit" disabled={!consent}>Submit</button>
                </Form>
              
                </div>
            )}
        </Formik>
    );
};

export default ChangiForm;

